var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-project-offers-list"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('ul',_vm._l((_vm.offers),function(offer){return _c(_setup.ProjectOffersListItem,{key:offer.id,attrs:{"offer":offer}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }